<template>
  <div
    class="w-16 h-16 fixed bottom-0 right-0 mb-16 mr-6 rounded-full bg-white border-2 border-primary-500 text-black grid items-center justify-center z-30 shadow-md hover:bg-primary-500 cursor-pointer"
    :class="css"
    @click="emitInput"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "Fab",
  data() {
    return {};
  },
  props: {
    css: {
      type: String,
      default: ""
    }
  },
  components: {},
  methods: {
    emitInput() {
      this.$emit("input");
    }
  },
  computed: {},
  created() {}
};
</script>
